exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".EYUqcjRCy0{padding:15px;text-align:center;background-color:#ffcc4d}._1lYOXUAVJl{font-size:30px;font-weight:700;padding:30px 0 20px;text-transform:uppercase;text-align:center}@media (max-width:850px){._1lYOXUAVJl{font-size:20px;padding:10px}}._3pa09nj7jT{padding:0 60px 20px}@media (max-width:850px){._3pa09nj7jT{padding:0 10px 10px}}._2kytZJapMN{padding:20px 60px 30px;border-top:1px solid #f0f0f0}@media (max-width:850px){._2kytZJapMN{padding:10px}}._1xtiDEKnAq+._1xtiDEKnAq{margin-left:15%}", ""]);

// exports
exports.locals = {
	"stat": "EYUqcjRCy0",
	"title": "_1lYOXUAVJl",
	"form": "_3pa09nj7jT",
	"item": "_2kytZJapMN",
	"number": "_1xtiDEKnAq"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!./~/postcss-loader!./~/sass-loader?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./src/react/elements/ReviewList/ReviewList.scss
// module id = 952
// module chunks = 20